import React from "react";
import "./OurGlobalClient.css";
import "../HomePage/OurTechAndFram/OurTechAndFrame.css";

const OurGlobalClient = () => {
  return (
    <section
      id="global"
      className="text-center position-relative overflow-hidden"
      style={{
        backgroundColor: "#0B4F5D",
        color: "#fff",
      }}
    >
      {/* Background Image */}
      <img
        src="https://res.cloudinary.com/davmkct9m/image/upload/v1769585494/Jumbotron_1_bc4goz.png"
        alt="Our Global Clients"
        className="global-image"
        style={{
          objectFit: "cover",
          opacity: 0.95,
        }}
      />

      {/* Text Overlay */}
      <div
        className="position-absolute text-white px-3 text-overlay"
        style={{
          
        }}
      >
        <h2 className="fw-semibold Tech-heading_GC mb-4">
          Working Across Borders, Rooted In Trust
        </h2>

        <p
          className="mb-4 mx-auto Tech-heading_GC_Desc"
          
        >
          Our story began in Bangladesh, but a large part of our professional
          lives takes place in the UK. We have partnered closely with UK-based
          companies that recognize the importance of effective communication,
          regular delivery, and a team that feels local despite being thousands
          of miles away.
        </p>
      </div>
    </section>
  );
};

export default OurGlobalClient;
